export const getOrderUtils = (order) => {
    const { airOrder } = order;
    const { flightSegments, airlineReferencesByLeg } = airOrder;
    const isOneWay = flightSegments.length === 1;
    const isRoundTrip = flightSegments.length === 2 && flightSegments[0].departureAirport.code === flightSegments[1].arrivalAirport.code;
    const isMultiStop = (flightSegments.length === 2 &&
        flightSegments[0].departureAirport.code !== flightSegments[1].arrivalAirport.code) ||
        flightSegments.length > 2;
    const getHcUniqueOrderId = (flightSegment) => {
        return `${order.publicReference.formattedReference}_${flightSegment.departureAirport.code}-${flightSegment.arrivalAirport.code}`;
    };
    const isAirlineReferenceReceived = !!airlineReferencesByLeg;
    const tripType = isOneWay ? "ONEWAY" : isRoundTrip ? "ROUNDTRIP" : isMultiStop ? "MULTISTOP" : undefined;
    return {
        isOneWay,
        isRoundTrip,
        isMultiStop,
        isAirlineReferenceReceived,
        tripType,
        getHcUniqueOrderId
    };
};
